import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import "./lookup.css";

import Lookup from "./Lookup";

// Randomize the lava blobs' animation phases so every page load shows a
// different snapshot of the lamp. Each blob has two animations (bob + morph);
// we offset each independently with negative animation-delay so they're
// already mid-cycle at mount time.
const rand = (min: number, max: number) => Math.random() * (max - min) + min;
const root = document.documentElement;
const blobs = ["a", "b", "c", "d", "e"] as const;
for (const k of blobs) {
  root.style.setProperty(`--lava-${k}-bob-delay`, `-${rand(0, 60)}s`);
  root.style.setProperty(`--lava-${k}-morph-delay`, `-${rand(0, 24)}s`);
}

createRoot(document.getElementById("lookup-root")!).render(
  <StrictMode>
    <Lookup />
  </StrictMode>,
);
